export const BlueSeparator = () => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: decorative separator, no title needed
  <svg
    width="100%"
    preserveAspectRatio="none"
    height="2"
    viewBox="0 0 180 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 1.00003L180 1.00005" stroke="#47BCD8" strokeWidth="2" />
  </svg>
);
